<template>
  <div class="app-container" v-show="isLogin">
    <!-- 充值记录 -->
    <div style="text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        <el-table
          v-loading="listLoading"
          :data="rechargeList"
          highlight-current-row
          style="color: rgb(70, 70, 70); margin-top: 10px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <el-table-column label="操作时间" align="left" min-width="2">
            <template slot-scope="{ row }">
              <span>{{ row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.type">{{ row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充值金币" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.change_money">{{
                row.change_money
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="剩余金币" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.change_money_balance">{{
                row.change_money_balance
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作说明" min-width="6" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.remarks">{{ row.remarks }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="rechargeTotal > 0"
          :total="rechargeTotal"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.perPage"
          style="padding-top: 12px; padding-bottom: 0px; text-align: center"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "czjl",
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      isLogin: false,
      rechargeList: [],
      rechargeTotal: 0,
      listLoading: false,
      listQuery: {
        type: 1,
        page: 1,
        perPage: 20,
        // date_one: "",
        // date_two: "",
        // order: "",
        status: 1,
      },
      rech_startDate: "2022-12-01 00:00:00",
      rech_endDate: new Date(),
      rech_pickerOptionsStart: {
        disabledDate: (time) => {
          let rech_endDateVal = this.rech_endDate;
          if (rech_endDateVal) {
            return time.getTime() > new Date(rech_endDateVal).getTime(); //选则的时间
          }
        },
      },
      rech_pickerOptionsEnd: {
        disabledDate: (time) => {
          let rech_beginDateVal = this.rech_startDate;
          if (rech_beginDateVal) {
            return time.getTime() < new Date(rech_beginDateVal).getTime();
          }
        },
      },
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
          return;
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
          return;
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
  },
  methods: {
    async getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
            return;
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
            return;
          });
        return;
      }

      this.rechargeList = [];
      // this.listQuery.date_one = this.rech_startDate;
      // const end = this.rech_endDate;
      // const endday = end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate();
      // const now = new Date();
      // const nowday = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      // if (endday != nowday) {
      //   this.listQuery.date_two = this.rech_endDate;
      // }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/UserFlow";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          // if (resd.data.length > 0) {
          if (resd.code == "200") {
            this.rechargeList = resd.data.data;
            this.rechargeTotal = resd.data.total;

            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

.spanColors {
  /* color: #409eff; */
  font-weight: bold;
  border-top: rgb(221, 221, 221) 1px solid;
  border-right: rgb(221, 221, 221) 1px solid;
  border-left: rgb(221, 221, 221) 1px solid;
  border-bottom: white 2px solid;
  border-top-left-radius: 0.3em;
  border-top-right-radius: 0.3em;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/cwmx/czjl/index.vue